import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  RiStore2Line,
  RiMedicineBottleLine,
  RiUserFollowLine,
  RiPriceTag3Line,
  RiImageLine,
  RiArchiveLine,
  RiCloseLine,
  RiMenuFoldLine,
  RiMenuUnfoldLine,
  RiFileList3Line,
  RiFileTextLine,
  RiLayoutFill,
  RiArrowDownSLine,
  RiLogoutBoxLine
} from 'react-icons/ri';
import { GiHamburgerMenu } from "react-icons/gi";
import { useAuth } from '../contexts/AuthContext';
import { logoutUtils } from '../utils/logoutUtils';
import './AdminDashboard.css';
import { FaArrowLeft } from "react-icons/fa";
import AddMedicalStore from './AddMedicalStore/AddMedicalStore';
import AddMedicine from './AddMedicine/AddMedicine';
import AddMedicineFromExcel from './Addexcel/AddMedicineFromExcel';
import EmployeeList from './UserVarification/EmployeeList';
import AddCategory from './AddCategeory/AddCategory';
import DeleteCategory from './AddCategeory/CategoryList/CategoryList';  // Import Delete Category Component
import AddSlider from './AddSlider/AddSlider';
import DeleteSlider from './DeleteSlider/DeleteSlider';
import AddCollection from './Collection/Collection';
import DeleteCollection from './Collection/DeleteCollection';
import SelectScrollCategory from './AddCategeory/CategoryList/ShowScrollCategory';  // Import Select Scroll Category Component
import PrescriptionManagement from './Prescription/PrescriptionManagement';
import MedicineManagement from './Medicine/MedicineManagement';
import MedicalStoreManagement from './MedicalStore/MedicalStoreManagement';
import FormPage from './DoctorAppointment/FormPage';
import BlogManagement from './Blog/BlogManagement';
import BannerManagement from './Banner/BannerManagement';
import AddHospital from './HospitalManage/AddHospital';
import HospitalManagement from './HospitalManage/HospitalManage';
import AddDoctor from './HospitalManage/AddDoctor';
import AddDoctorCategory from './AddCategeory/AddDoctorCategory';
import ShowScrollDoctorCategory from './AddCategeory/CategoryList/ShowScrollDoctorCategory';
import DoctorManagement from './HospitalManage/ManageDocter';
import OrderManagement from './OrderManagement/OrderManagement';
import LeadsManagement from './LeadsManagement/LeadsManagement';
import LabTestManagement from './LabTestManagement/LabTestManagement';
import AddEmployee from './EmployeeManagement/AddEmployee';
import EmployeeManagement from './EmployeeManagement/ManageEmployee';
import RedemptionManagement from '../dashboard/pages/RedemptionManagement';

function AdminDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [selectedOption, setSelectedOption] = useState({ category: null, option: null });
  const [formVisibility, setFormVisibility] = useState({
    leadManagement: false,
    addMedicalStore: false,
    manageMedicalStores: false,
    managedoctors: false,
    editMedicalStore: false,
    deleteMedicalStore: false,
    addMedicine: false,
    addMedicineExcel: false,
    verifyUser: false,
    addCategory: false,
    deleteCategory: false, // Add Delete Category visibility
    selectScrollCategory: false, // Add Select Scroll Category visibility
    addDoctorCategory: false,
    showScrollDoctorCategory: false,
    addSlider: false,
    deleteSlider: false,
    addCollection: false,
    deleteCollection: false,
    prescriptionManagement: false,
    manageMedicines: false,
    formPage: false,
    manageBlog: false,
    manageBanner: false,
    addHospital: false,
    addDoctor: false,
    manageHospital: false,
    deleteHospital: false,
    editHospital: false,
    orderManagement: false,
    labTestManagement: false,
    employeeMangement: false,
    addemployee: false,
    redemptionManagement: false,
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

 const menuRef = useRef(null);
  useEffect(() => {
      const handleClickOutside = (event) => {
        // console.log(event.target, menuRef.current);
        if (window.innerWidth <= 768 && !event.target.closest(".sidebar")) {
          setIsSidebarOpen(false);
      }
      };
  
      // Add event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
          document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);

  const handleClick = (category, option) => {
    // If no specific option is provided, use the first option from the menu item
    const menuItem = menuOptions.find(item => item.category === category);
    const defaultOption = menuItem?.options?.[0]?.value;
    const finalOption = option || defaultOption;

    setSelectedOption({ category, option: finalOption });
    setFormVisibility({
      leadManagement: category === 'leads' && (finalOption === 'manage' || !finalOption),
      addMedicalStore: category === 'medicalStore' && (finalOption === 'add' || !finalOption),
      manageMedicalStores: category === 'medicalStore' && finalOption === 'manage',
      editMedicalStore: category === 'medicalStore' && finalOption === 'edit',
      deleteMedicalStore: category === 'medicalStore' && finalOption === 'delete',
      addHospital: category === 'hospital' && (finalOption === 'add' || !finalOption),
      managedoctors: category === 'hospital' && finalOption === 'managedoctors',
      addDoctor: category === 'hospital' && finalOption === 'addDoctor',
      manageHospital: category === 'hospital' && finalOption === 'manage',
      editHospital: category === 'hospital' && finalOption === 'edit',
      deleteHospital: category === 'hospital' && finalOption === 'delete',
      addMedicine: category === 'medicine' && (finalOption === 'single' || !finalOption),
      addMedicineExcel: category === 'medicine' && finalOption === 'excel',
      verifyUser: category === 'verifyUser',
      addCategory: category === 'category' && (finalOption === 'add' || !finalOption),
      deleteCategory: category === 'category' && finalOption === 'delete',
      selectScrollCategory: category === 'category' && finalOption === 'scroll',
      addDoctorCategory: category === 'hospital' && finalOption === 'addDoctorCategory',
      showScrollDoctorCategory: category === 'hospital' && finalOption === 'showScrollDoctorCategory',
      addSlider: category === 'slider' && (finalOption === 'add' || !finalOption),
      deleteSlider: category === 'slider' && finalOption === 'delete',
      addCollection: category === 'collection' && (finalOption === 'add' || !finalOption),
      deleteCollection: category === 'collection' && finalOption === 'delete',
      prescriptionManagement: category === 'prescriptions' && (finalOption === 'manage' || !finalOption),
      formPage: category === 'appointment' && (finalOption === 'appointment' || !finalOption),
      manageMedicines: category === 'medicine' && finalOption === 'manage',
      manageBlog: category === 'blog' && (finalOption === 'manage' || !finalOption),
      manageBanner: category === 'banner' && (finalOption === 'manage' || !finalOption),
      orderManagement: category === 'orders' && (finalOption === 'manage' || !finalOption),
      labTestManagement: category === 'labTest' && (finalOption === 'manage' || !finalOption),
      employeeMangement: category === 'employee' && (finalOption === 'manage' || !finalOption),
      addemployee: category === 'employee' && (finalOption === 'add' || !finalOption),
      redemptionManagement: category === 'redemption' && (finalOption === 'manage' || !finalOption),
    });
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    logoutUtils.confirmLogout(() => {
      logoutUtils.performLogout(navigate, logout);
    });
  };

  const menuOptions = [
    {
      label: 'From Popup',
      icon: RiFileList3Line,
      category: 'leads',
      options: [
        { label: 'Manage popup', value: 'manage' }
      ],
    },
    {
      label: 'Medical Store',
      icon: RiStore2Line,
      options: [
        { label: 'Add Medical Store', value: 'add' },
        { label: 'Manage Stores', value: 'manage' }
      ],
      category: 'medicalStore',
    },
    // {
    //   label: 'Hospital',
    //   icon: RiStore2Line,
    //   options: [
    //     { label: 'Add Hospital', value: 'add' },
    //     {label: "Add Doctor", value: "addDoctor"},
    //     { label: 'Manage Hospital', value: 'manage' }
    //   ],
    //   category: 'hospital',
    // },
    {
      label: 'Hospital',
      icon: RiStore2Line,
      options: [
        { label: 'Add Hospital', value: 'add' },
        { label: 'Manage Hospital', value: 'manage' },
        { label: 'Manage Doctors', value: 'managedoctors' },
        { label: 'Add Doctor Category', value: 'addDoctorCategory' },
        { label: 'Add Doctor', value: 'addDoctor' },
        { label: 'Select Doctor Category', value: 'showScrollDoctorCategory' }

      ],
      category: 'hospital',
    },
    {
      label: 'Medicine',
      icon: RiMedicineBottleLine,
      options: [
        { label: 'Add Medicine', value: 'single' },
        // { label: 'Upload Medicines (Excel)', value: 'excel' },
        { label: 'Manage Medicines', value: 'manage' }
      ],
      category: 'medicine',
    },
    {
      label: 'Verify User',
      icon: RiUserFollowLine,
      category: 'verifyUser'
    },
    {
      label:'Employee Management',
      icon: RiUserFollowLine,
      category: 'employee',
      options: [
        { label: 'Add Employee', value: 'add' },
        { label: 'Manage Employee', value: 'manage' }
      ]

    },
    {
      label: 'Department & Category',
      icon: RiPriceTag3Line,
      category: 'category',
      options: [
        { label: 'Add', value: 'add' },
        { label: 'Delete', value: 'delete' },
        { label: 'Select Departments', value: 'scroll' },
      ],
    },
    {
      label: 'Slider',
      icon: RiImageLine,
      category: 'slider',
      options: [
        { label: 'Add Slider', value: 'add' },
        { label: 'Delete Slider', value: 'delete' },
      ],
    },
    {
      label: 'Collection',
      icon: RiArchiveLine,
      category: 'collection',
      options: [
        { label: 'Add Collection', value: 'add' },
        { label: 'Delete Collection', value: 'delete' },
      ],
    },
    {
      label: 'Prescriptions',
      icon: RiFileList3Line,
      category: 'prescriptions',
      options: [
        { label: 'Manage Prescriptions', value: 'manage' }
      ],
    },
    {
      label: 'Appointment',
      icon: RiFileList3Line,
      category: 'appointment',
      options: [
        { label: 'Manage Appointment', value: 'appointment' }
      ],
    },
    {
      label: 'Lab Tests', // New Menu Item for Lab Tests
      icon: RiFileList3Line,
      category: 'labTest',
      options: [
        { label: 'Manage Lab Tests', value: 'manage' }
      ],
    },
    {
      label: 'Blog',
      icon: RiFileTextLine,
      category: 'blog',
      options: [
        { label: 'Manage Blogs', value: 'manage' }
      ],
    },
    {
      label: 'Banner',
      icon: RiLayoutFill,
      category: 'banner',
      options: [
        { label: 'Manage Banners', value: 'manage' }
      ],
    },
    {
      label: 'Orders',
      icon: RiFileList3Line,
      category: 'orders',
      options: [
        { label: 'Manage Orders', value: 'manage' }
      ],
    },
    {
      label: 'Coin Redemption',
      icon: RiArchiveLine,
      category: 'redemption',
      options: [
        { label: 'Manage Redemptions', value: 'manage' }
      ],
    },
  ];

  return (
    <div className={`admin-dashboard ${!isSidebarOpen ? 'sidebar-collapsed' : ''}`}  ref={menuRef}>

      <motion.div
        className={`sidebar ${!isSidebarOpen ? 'collapsed' : ''}`}
        initial={{ x: -300 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <div className="sidebar-header">
          <h2 style={{ color: "white" }}>Admin <br /> Dashboard</h2>
          
          {/* User Info Section */}
          <div className="user-info" style={{
            padding: '10px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '8px',
            margin: '10px 0',
            fontSize: '14px',
            color: 'white'
          }}>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
              Welcome, {user?.name || 'Admin'}
            </div>
            <div style={{ fontSize: '12px', opacity: 0.8 }}>
              Role: {user?.role || 'Administrator'}
            </div>
          </div>
          
          {/* Logout Button */}
          <motion.button
            className="logout-btn"
            onClick={handleLogout}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{
              width: '100%',
              padding: '10px 15px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              marginBottom: '20px',
              transition: 'all 0.3s ease'
            }}
          >
            <RiLogoutBoxLine style={{ fontSize: '16px' }} />
            Logout
          </motion.button>
        </div>
        <motion.button
          className="sidebar-toggle"

          onClick={toggleSidebar}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          {isSidebarOpen ? (
            <GiHamburgerMenu style={{ transition: 'transform 0.3s' }} />
          ) : (
            <GiHamburgerMenu style={{ transition: 'transform 0.3s' }} />
          )}
        </motion.button>

        <ul>
          {menuOptions.map((menuItem) => (
            <motion.li
              key={menuItem.category}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <button
                className={`sidebar-btn ${selectedOption.category === menuItem.category ? 'active' : ''}`}
                onClick={() => handleClick(menuItem.category)}
              >
                <div className="sidebar-btn-content">
                  <div className="btn-left">
                    <menuItem.icon className="menu-icon" />
                    <span>{menuItem.label}</span>
                  </div>
                  {menuItem.options && (
                    <RiArrowDownSLine
                      className={`dropdown-arrow ${selectedOption.category === menuItem.category ? 'rotated' : ''
                        }`}
                    />
                  )}
                </div>
              </button>
              <AnimatePresence>
                {selectedOption.category === menuItem.category && menuItem.options && (
                  <motion.ul
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                    className="submenu"
                  >
                    {menuItem.options.map((option) => (
                      <motion.li
                        key={option.value}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <button
                          className={`sub-menu-btn ${selectedOption.category === menuItem.category &&
                            selectedOption.option === option.value
                            ? 'active'
                            : ''
                            }`}
                          onClick={() => handleClick(menuItem.category, option.value)}
                        >
                          {option.label} <span>+</span>
                        </button>
                      </motion.li>
                    ))}
                  </motion.ul>
                )}
              </AnimatePresence>
            </motion.li>
          ))}
        </ul>
      </motion.div>

      <motion.div
        className={`content ${!isSidebarOpen ? 'expanded' : ''}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <h3>Welcome to the Admin Dashboard</h3>
        <p>Select an option from the sidebar to perform an operation.</p>

        <AnimatePresence mode="wait">
          {Object.entries(formVisibility).map(([key, isVisible]) =>
            isVisible && (
              <motion.div
                key={key}
                className={`${key}-section form-section`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.2 }}
              >
                <motion.button
                  className="close-btn"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() =>
                    setFormVisibility({ ...formVisibility, [key]: false })
                  }
                >
                  <RiCloseLine />
                </motion.button>
                {/* Render the appropriate component based on the key */}
                
                {key === 'leadManagement' && <LeadsManagement/>}
                {key === 'addMedicalStore' && <AddMedicalStore />}
                {key === 'manageMedicalStores' && <MedicalStoreManagement />}
                {key === 'addHospital' && <AddHospital />}
                {key === 'managedoctors' && <DoctorManagement />}
                {key === 'addDoctor' && <AddDoctor />}
                {key === 'manageHospital' && <HospitalManagement />}
                {key === 'formPage' && <FormPage />}
                {key === 'addMedicine' && <AddMedicine />}
                {key === 'addMedicineExcel' && <AddMedicineFromExcel />}
                {key === 'verifyUser' && <EmployeeList />}
                {key === 'addCategory' && <AddCategory />}
                {key === 'deleteCategory' && <DeleteCategory />}
                {key === 'selectScrollCategory' && <SelectScrollCategory />}
                {key === 'addSlider' && <AddSlider />}
                {key === 'deleteSlider' && <DeleteSlider />}
                {key === 'addCollection' && <AddCollection />}
                {key === 'deleteCollection' && <DeleteCollection />}
                {key === 'prescriptionManagement' && <PrescriptionManagement />}
                {key === 'labTestManagement' && <LabTestManagement/>}
                {key === 'manageMedicines' && <MedicineManagement />}
                {key === 'manageBlog' && <BlogManagement />}
                {key === 'manageBanner' && <BannerManagement />}
                {key === 'addDoctorCategory' && <AddDoctorCategory />}
                {key === 'showScrollDoctorCategory' && <ShowScrollDoctorCategory />}
                {key === 'orderManagement' && <OrderManagement />}
                {key === 'employeeMangement' && <EmployeeManagement />}
                {key === 'addemployee' && <AddEmployee />}
                {key === 'redemptionManagement' && <RedemptionManagement />}

              </motion.div>
            )
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
}

export default AdminDashboard;